import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./InfoSingle.css";

export default function InfoSingle({ styling, page_addressOnly, id, title, description_brief, thumbnail_src, banner_src, page_address, category, date }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    function generatePageAddress(page_addressOnly, page_address, id) {
        if (page_addressOnly) {
            if (page_address !== null) {
                const pageAddress = page_address;
                return pageAddress;
            }
            else {
                const pageAddress = id.toString();
                return pageAddress;
            }
        }
        else {
            if (page_address !== null) {
                const pageAddress = "notice/" + page_address;
                return pageAddress;
            }
            else {
                const pageAddress = "notice/" + id.toString();
                return pageAddress;
            }
        }
    }

    function capitalizeFirstLetter(targetString) {
        const output = String(targetString).charAt(0).toUpperCase() + String(targetString).slice(1);
        return output;
    }

    return (
        <div className="infosingle">
            <Link to={generatePageAddress(page_addressOnly,page_address,id)}>
                <div className="infosingle-content-img-wrapper" style={styling.boardType === "banner" ? {border: "none"} : {}}>
                    {styling.boardType === "banner" ?
                        <img src={isMobile || banner_src === null ? thumbnail_src : banner_src} alt={title} /> :
                        <img src={thumbnail_src} alt={title} />}
                </div>
                {styling.showTextDetails ? (
                    <div className="infosingle-content-text-wrapper">
                        <h3>{title}</h3>
                        <div className="infosingle-content-text-date">
                            <p>{date} - {capitalizeFirstLetter(category)}</p>
                        </div>
                        <p>{description_brief}</p>
                    </div>
                ) : null}
            </Link>
        </div>
    );
}